import { createContext, useContext, useState } from "react";

const EventContext = createContext();

export const useEventContext = () => useContext(EventContext);

export function EventProvider({ children }) {
  const [message, setMessage] = useState("");

  const triggerEvent = (value) => {
    setMessage(value);
  };

  return (
    <EventContext.Provider value={{ message, triggerEvent }}>
      {children}
    </EventContext.Provider>
  );
}
